import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-profile',
  standalone: false,
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  cards = [
    {
      title: 'Users',
      description: 'Manage user accounts and profiles',
      iconClass: 'pi pi-user',
      showButton: false,
      borderClass: 'bg-blue',
    },
    {
      title: 'Role',
      description: 'Add Roles ',
      iconClass: 'pi pi-key',
      showButton: false,
      borderClass: 'bg-orange',
    },
    {
      title: 'Proposal Mapping',
      description: 'Manage user assignments to proposals',
      iconClass: 'pi pi-link',
      showButton: false,
      borderClass: 'bg-yellow',
    },
    {
      title: 'Role Access',
      description: 'Configure roles access levels',
      iconClass: 'pi pi-lock',
      showButton: false,
      borderClass: 'bg-green',
    },
    {
      title: 'User Access',
      description: 'Configure user access levels',
      iconClass: 'pi pi-users',
      showButton: false,
      borderClass: 'bg-purple',
    },
    {
      title: 'Privileges',
      description: 'Manage system-wide privileges',
      iconClass: 'pi pi-cog',
      showButton: false,
      borderClass: 'bg-red',
    }
  ];
  roles = [];

  users = [
    { name: 'User 1' },
    { name: 'User 2' }
  ];

  selectedRole = null;
  selectedUser = null;

  permissions = ['Add', 'Edit', 'View', 'Delete'];

  modules = [
    {
      name: 'Dashboard',
      permissions: { Add: true, Edit: true, View: true, Delete: false },
      enabled: true
    },
    {
      name: 'Master',
      permissions: { Add: false, Edit: false, View: false, Delete: false },
      enabled: false
    },
    {
      name: 'System',
      permissions: { Add: false, Edit: false, View: false, Delete: false },
      enabled: true
    },
    {
      name: 'TEST',
      permissions: { Add: false, Edit: false, View: false, Delete: false },
      enabled: true
    }
  ];
  viewDetails: boolean = false;
  title: string = '';
  checked: boolean = false;
  treeData = [
    {
      data: {
        name: 'Dashboard',
        permissions: { Add: true, Edit: true, View: true, Delete: false },
        enabled: true
      }
    },
    {
      data: {
        name: 'Master',
        permissions: { Add: false, Edit: false, View: false, Delete: false },
        enabled: false,

      },
      expanded: true,
      children: [
        {
          data: {
            name: 'System',
            permissions: { Add: false, Edit: false, View: false, Delete: false },
            enabled: true
          }
        },
        {
          data: {
            name: 'TEST',
            permissions: { Add: false, Edit: false, View: false, Delete: false },
            enabled: true
          }
        }
      ]
    }
  ];
  flatModules = [
    // {
    //   name: 'Master',
    //   permissions: { View: true, Edit: true, Add: true, Delete: false },
    //   enabled: true,
    //   children: [
    //     {
    //       name: 'System',
    //       permissions: { View: true, Edit: false, Add: false, Delete: false },
    //       enabled: true
    //     },
    //     {
    //       name: 'Test',
    //       permissions: { View: true, Edit: false, Add: true, Delete: true },
    //       enabled: true
    //     }
    //   ]
    // },
    // {
    //   name: 'Dashboard',
    //   permissions: { View: true, Edit: true, Add: true, Delete: false },
    //   enabled: true,
    //   children: []
    // }
  ];
  showMenuDialog = false;

  menuForm!: FormGroup;
  viewUserDetails: boolean = false;
  viewPrivilegeDetails: boolean = false;
  viewProposalMappingDetails: boolean = false;
  viewUserwiseDetails: boolean = false;
  viewRoleDetails: boolean = false;
  switchModule: boolean = false;
  parentMenuOptions = [];
  private mySubscription = new Subscription();
  constructor(
    private apiService: ApiService, private fb: FormBuilder, private messageService: MessageService,
    private cdRef: ChangeDetectorRef, private router: Router) { }

  ngOnInit(): void {
    this.menuForm = this.fb.group({
      name: ['', Validators.required],
      url: ['/'],
      icon: ['MessageSquare'],
      parent: [null]
    });
  }

  viewDetailsClicked(card: any) {
    if (card.title == 'Role Access') {
      this.viewDetails = true;
      this.viewPrivilegeDetails = false;
      this.viewUserDetails = false;
      this.viewProposalMappingDetails = false;
      this.viewUserwiseDetails = false;
      this.viewRoleDetails = false
      if (this.switchModule) {
        this.switchModule = false;
      }
    } else if (card.title == 'User Access') {
      this.viewUserwiseDetails = true
      this.viewDetails = false;
      this.viewPrivilegeDetails = false;
      this.viewUserDetails = false;
      this.viewProposalMappingDetails = false;
      this.viewRoleDetails = false;
      if (this.switchModule) {
        this.switchModule = false;
      }
    }
    else if (card.title == 'Users') {
      this.viewUserDetails = true;
      this.viewDetails = false;
      this.viewPrivilegeDetails = false;
      this.viewProposalMappingDetails = false;
      this.viewUserwiseDetails = false;
      this.viewRoleDetails = false
      if (this.switchModule) {
        this.switchModule = false;
      }
    }
    else if (card.title == 'Proposal Mapping') {
      this.viewProposalMappingDetails = true;
      this.viewPrivilegeDetails = false;
      this.viewUserDetails = false;
      this.viewDetails = false;
      this.viewUserwiseDetails = false;
      this.viewRoleDetails = false
      if (this.switchModule) {
        this.switchModule = false;
      }
    }
    else if (card.title == 'Privileges') {
      this.viewPrivilegeDetails = true;
      this.viewProposalMappingDetails = false;
      this.viewUserDetails = false;
      this.viewDetails = false;
      this.viewUserwiseDetails = false
      this.viewRoleDetails = false
      if (this.switchModule) {
        this.switchModule = false;
      }
    } else if (card.title == 'Role') {
      this.viewRoleDetails = true;
      this.viewPrivilegeDetails = false;
      this.viewProposalMappingDetails = false;
      this.viewUserDetails = false;
      this.viewDetails = false;
      this.viewUserwiseDetails = false
      if (this.switchModule) {
        this.switchModule = false;
      }
    }
    this.title = card.title
  }

}
